import { render, staticRenderFns } from "./PrazoPagamento.vue?vue&type=template&id=4d0f5a6e&scoped=true"
import script from "./PrazoPagamento.vue?vue&type=script&lang=js"
export * from "./PrazoPagamento.vue?vue&type=script&lang=js"
import style0 from "./PrazoPagamento.vue?vue&type=style&index=0&id=4d0f5a6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0f5a6e",
  null
  
)

export default component.exports